var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('track-post-impression',{attrs:{"payload":_setup.postImpressionPayload}},[_c('video',{directives:[{name:"test-id",rawName:"v-test-id",value:('player'),expression:"'player'"}],ref:"videoPlayer",staticClass:"video-js vjs-fluid"})])
}
var staticRenderFns = []

export { render, staticRenderFns }